import React from 'react';
import { Switch } from 'react-router-dom';
import { Route, routes } from '@/app/routing/index';
import DecedentList from '@/pages/decedent-list/index';
import DecedentDetails from '@/pages/decedent-details/DecedentDetails';

const DecedentRoutes = () => (
  <Switch>
    <Route path={routes.adminPanel.decedents} component={DecedentList} exact />
    <Route
      path={`${routes.adminPanel.decedentProfile}:id`}
      component={DecedentDetails}
    />
  </Switch>
);

export default DecedentRoutes;
